class TabsCollection {
    constructor() {
        this.tabs = []
    }

    addTab(tab) {
        this.tabs.push(tab)
    }
}

class Tab {
    constructor(id, tables, isDefault, callback) {
        this.id = id
        this.isDefault = isDefault
        this.tables = tables
        this.callback = callback
        this.initialized = false
        this.button = $('button[data-id="'+this.id+'"]')
        this.button.click(() => {
            this.addHashToLocation()
            if (this.initialized === false) {
                this.loadTab()
            } else {
                $.each(this.tables, (tableId) => refreshBootstrapTable(tableId))
            }
        })
        this.url = this.button.attr('data-url')
        this.target = this.button.attr('data-bs-target')
        if (this.isDefault === true) {
            this.loadTab()
        }
    }

    loadTab() {
        $.ajax({
            url: this.url,
            type: 'GET',
            success: (data) => {
                if ($(this.target).length) {
                    $(this.target).empty().html(data);
                }
                $.each(this.tables, (tableId, table) => initBootstrapTable(tableId, table, false))
                if (typeof this.callback !== 'undefined') {
                    let fn = window[this.callback];
                    if (typeof fn === 'function') {
                        fn();
                    }
                }
            }
        })
        this.button.tab('show')
        this.initialized = true
    }
    addHashToLocation() {
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        if (isChrome) {
            window.location.hash = "";
        } else if (!this.button.attr("data-dont-toggle-to-hash")) {
            window.location.hash = "#"+this.id;
        }
    }
}

window.initTabs = function() {
    tables = typeof tables === 'undefined' ? {} : tables

    const getDefaultTabId = function (tabs) {
        if (tabs.hasOwnProperty('default') === true || window.location.hash.length > 0) {
            return window.location.hash.length > 0
                ? window.location.hash.split("#")[1]
                : tabs.default.id
        }
        return null
    }

    const defaultId = getDefaultTabId(tabs)
    const tabsCollection = new TabsCollection()

    $.each(tabs, function (tabId, tab) {
        if (typeof tab.tables !== 'undefined' && Object.keys(tab.tables).length > 0) {
            $.extend(tables, tab.tables)
        }
        tabsCollection.addTab(new Tab(tabId, tab.tables, tabId === defaultId, tab.callback));
    })
};
